import { IconPropsType } from '..';

export const FlagIcon = ({ ...props }: IconPropsType) => (
  <svg
    width="20"
    height="20"
    viewBox="0 0 20 20"
    xmlns="http://www.w3.org/2000/svg"
    {...props}
  >
    <path d="M3 18V2H11.4L11.7733 3.88235H17V13.2941H10.4667L10.0933 11.4118H4.86667V18H3ZM12.0067 11.4118H15.1333V5.76471H10.2333L9.86 3.88235H4.86667V9.52941H11.6333L12.0067 11.4118Z" />
  </svg>
);
